var _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediaArrow2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 45,
    viewBox: "0 0 27 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -2.5,
    x2: 29.6622,
    y2: -2.5,
    transform: "matrix(-0.658125 0.752909 0.792996 0.609228 24.1621 4)",
    stroke: "white",
    strokeWidth: 5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -2.5,
    x2: 30.6077,
    y2: -2.5,
    transform: "matrix(-0.756541 -0.653946 -0.655058 0.755579 23.1562 44.0157)",
    stroke: "white",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaArrow2);
export default __webpack_public_path__ + "static/media/media_arrow2.266084ddd03f514556c773e9922d2ad8.svg";
export { ForwardRef as ReactComponent };